import { render, staticRenderFns } from "./ScreenCreaEliminaCodigosBodega.vue?vue&type=template&id=d696dd22"
import script from "./ScreenCreaEliminaCodigosBodega.vue?vue&type=script&lang=js"
export * from "./ScreenCreaEliminaCodigosBodega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports